module.exports = __webpack_public_path__ + "static/media/htmlPro1.7fa60248.PNG";